module.exports = __webpack_public_path__ + "img/portugal-lung-cancer-female.49f3f76c.png";